import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import AddIcon from '@material-ui/icons/Add'
// Local Components
import { User } from '../../API'
import { AutoCompleteComp, ChangeFunc } from '../../components/AutoCompleteComp'
import { useGlobalData } from '../../utils/hooks/global-data'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex'
  },
  search: {
    minWidth: '300px'
  },
  createBtn: {
    textAlign: 'center',
    padding: theme.spacing(1.5)
  }
}))

interface Props {
  data: User[]
  selectedOption?: User | null
  onSelect?: (username: string) => void
  openForm?: (isEdit?: boolean) => void
}

const UserSelection: FC<Props> = (props) => {
  const {
    data,
    onSelect,
    selectedOption,
    openForm
  } = props
  const classes = useStyles()
  const history = useHistory()
  const [, , globalDataToSearchParams] = useGlobalData()

  const handleSearchChange: ChangeFunc<{ Username: string }> = (_, option) => {
    if (!option) {
      return
    }
    const { Username } = option
    history.push(`/users/${Username}?${globalDataToSearchParams()}`)
    onSelect?.(Username)
  }

  const getUserSelected = (option: object, value: object) => {
    const { Username: optionUser } = option as User
    const { Username: valueUser } = value as User
    if (!valueUser) { return true }
    return optionUser === valueUser
  }

  const handleAddClick = () => openForm?.()

  return (
    <div className={classes.container}>
      <div className={classes.search}>
        <AutoCompleteComp
          value={selectedOption || {}}
          options={data}
          getOptionLabel={(options) => options.Name || ''}
          getOptionSelected={getUserSelected}
          handleChange={handleSearchChange}
          label="User"
        />
      </div>
      <div className={classes.createBtn}>
        <Button
          size="small"
          color="secondary"
          endIcon={<AddIcon />}
          onClick={handleAddClick}
        >
          Create User
        </Button>
      </div>
    </div>
  )
}

export { UserSelection }
